export const DEFAULT_ERROR_MESSAGES: Record<number, string> = {
  // Erros do Cliente (4xx)
  400: "Requisição inválida. Verifique os dados enviados.",
  401: "Não autorizado. Faça login novamente.",
  403: "Acesso negado. Você não tem permissão para esta operação.",
  404: "Recurso não encontrado.",
  408: "Tempo de requisição esgotado. Tente novamente.",
  409: "Conflito detectado. O recurso já existe ou está em uso.",
  422: "Dados inválidos. Verifique as informações fornecidas.",
  429: "Muitas requisições. Aguarde um momento e tente novamente.",

  // Erros do Servidor (5xx)
  500: "Ocorreu uma falha não tratada na execução.",
  502: "Erro de comunicação com o servidor. Tente novamente mais tarde.",
  503: "Serviço temporariamente indisponível. Tente novamente em alguns instantes.",
  504: "Tempo de resposta do servidor esgotado. Tente novamente.",

  // Erro de rede
  0: "Erro de conexão. Verifique sua internet e tente novamente.",
};

export const getErrorMessage = (
  statusCode: number | undefined,
  backendMessage?: string
): string => {
  // Prioridade 1: Mensagem do backend (se existir e não for vazia)
  if (backendMessage && backendMessage.trim() !== '') {
    return backendMessage;
  }

  // Prioridade 2: Mensagem padrão para o status code
  if (statusCode && DEFAULT_ERROR_MESSAGES[statusCode]) {
    return DEFAULT_ERROR_MESSAGES[statusCode];
  }

  // Fallback genérico
  return statusCode
    ? `Erro na requisição (${statusCode}).`
    : "Ocorreu um erro inesperado.";
};
